import React from "react";
import SiteHeader from "../components/SiteHeader";
import Footer from "../components/Footer";
import PageBanner from "../components/PageBanner";
import Projects from "../components/homi/Projects";
import ProjectGallery from "../components/homi/ProjectGallery";
import Transformations from "../components/homi/Transformations";
import ContactCta from "../components/homi/ContactCta";

export default function ProjectsPage() {
  return (
    <div className="App bg-white">
      <SiteHeader />
      <main>
        <PageBanner title="Our Projects" crumb="Projects" subtitle="A showcase of builds and renovations we're proud of." />
        <Projects />
        <Transformations />
        <ProjectGallery />
        <ContactCta />
      </main>
      <Footer />
    </div>
  );
}
